import React, { useState, useEffect } from "react";

import avatarString from "../util/avatar";

const AvatarCircle = ({letters, size, textSize}) => {
  // Array of some Tailwind color classes
  const colors = [
    "bg-red-500", "bg-blue-500", "bg-green-500", "bg-yellow-500", 
    "bg-purple-500", "bg-pink-500", "bg-indigo-500", "bg-teal-500"
  ];

  // Randomly select a color
  const getRandomColor = () => colors[Math.floor(Math.random() * colors.length)];


  // Store random color and letters
  const [color, setColor] = useState(getRandomColor());

  useEffect(() => {
    // Update the color and letters when the component mounts or updates
    setColor(getRandomColor());
  }, []);

  return (
    <div className={`${size ? size : "size-24"} flex items-center justify-center ${color} rounded-full`}>
      <span className={`text-white font-bold ${textSize ? textSize : "text-xl"}`}>{avatarString(letters)}</span>
    </div>
  );
};

export default AvatarCircle;